var _excluded = ["ratio", "src", "alt", "objectFit", "title", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, oneOf } from 'prop-types';
import classNames from 'classnames';
import './Image.scss';
var propTypes = {
  /** The source of the image */
  src: string.isRequired,

  /** When applied it will keep the aspect ratio of the image  */
  ratio: oneOf(['none', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1']),

  /** Always provide an alt text describing the image.
   * The alt attribute provides alternative information for an image
   * if a user for some reason cannot view it (because of slow connection,
   * an error in the src attribute, or if the user uses a screen reader). Example: `<Image src="bird.jpg" alt="A bird sitting on a branch. Photo." />`
   *
   * If the image is inside a link, the _target_ should be described, not the motif:
   * `<a href="buy-tickets.html"><Image src="image.jpg" alt="Buy tickets" /></a>`
   *
   * If the image is purely for decoration, provide an empty alt attribute: `<Image src="decoration.jpg" alt="" />` */
  alt: string,

  /** How the image should behave in its container */
  objectFit: oneOf(['fill', 'contain', 'cover', 'scale-down', 'none']),

  /** Specifies extra information about the image. Displays as a native tooltip when image is hovered. */
  title: string,

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  alt: '',
  ratio: 'none'
};
/** The Image component renders an image. In addition it can handle aspect ratios. */

var Image = function Image(_ref) {
  var ratio = _ref.ratio,
      src = _ref.src,
      alt = _ref.alt,
      objectFit = _ref.objectFit,
      title = _ref.title,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClasses = classNames('rds-image', {
    'rds-ratio': ratio !== 'none',
    'rds-ratio--16-9': ratio === '16:9',
    'rds-ratio--9-16': ratio === '9:16',
    'rds-ratio--4-3': ratio === '4:3',
    'rds-ratio--3-4': ratio === '3:4',
    'rds-ratio--3-2': ratio === '3:2',
    'rds-ratio--2-3': ratio === '2:3',
    'rds-ratio--1-1': ratio === '1:1'
  }, className);
  var imageClasses = classNames('rds-ratio__item', 'rds-image__img', {
    'rds-image--object-fit-fill': objectFit === 'fill',
    'rds-image--object-fit-contain': objectFit === 'contain',
    'rds-image--object-fit-cover': objectFit === 'cover',
    'rds-image--object-fit-scale-down': objectFit === 'scale-down',
    'rds-image--object-fit-none': objectFit === 'none'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: componentClasses
  }, /*#__PURE__*/React.createElement("img", _extends({
    className: imageClasses,
    src: src,
    alt: alt,
    title: title
  }, rest)));
};

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;
export default Image;